<template>
  <div>
    <div class="d-flex flex-wrap mb-2" style="gap:14px;">
      <span v-for="(s, i) in sources" :key="s" class="d-inline-flex align-items-center text-secondary" style="font-size:12px;gap:6px;">
        <span :style="{ width: '10px', height: '10px', borderRadius: '3px', background: colors[i % colors.length] }"></span>
        {{ s }} <strong class="text-dark">{{ short(total(s)) }}</strong>
      </span>
    </div>
    <div style="position:relative;height:240px;">
      <canvas ref="canvas"></canvas>
    </div>
    <div class="text-secondary mt-1" style="font-size:11px;">Charged per {{ trend.unit }}, incl. VAT</div>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

/** Stacked bars: income charged per day/week/month, one colour per source. */
export default {
  name: 'IncomeBySourceChart',

  props: {
    trend: { type: Object, required: true }, // { unit, labels, series: { Sales: [...], Memberships: [...] } }
  },

  data() {
    return {
      colors: ['#fd4719', '#343a40', '#6c757d', 'rgba(253,71,25,0.45)'],
    };
  },

  computed: {
    sources() {
      return Object.keys(this.trend.series || {});
    },
  },

  watch: {
    trend() { this.render(); },
  },

  mounted() { this.render(); },

  beforeDestroy() { if (this.chart) this.chart.destroy(); },

  methods: {
    total(source) {
      return (this.trend.series[source] || []).reduce((a, b) => a + b, 0);
    },

    short(v) {
      if (v >= 1e6) return 'KES ' + (v / 1e6).toFixed(1) + 'M';
      if (v >= 1e3) return 'KES ' + (v / 1e3).toFixed(0) + 'K';
      return 'KES ' + Math.round(v).toLocaleString('en-US');
    },

    render() {
      if (this.chart) this.chart.destroy();
      if (!this.$refs.canvas) return;

      this.chart = new Chart(this.$refs.canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: this.trend.labels || [],
          datasets: this.sources.map((s, i) => ({
            label: s,
            data: this.trend.series[s],
            backgroundColor: this.colors[i % this.colors.length],
            borderRadius: 4,
            maxBarThickness: 28,
          })),
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: { duration: 200 },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#1e293b',
              padding: 10,
              cornerRadius: 6,
              callbacks: { label: ctx => ` ${ctx.dataset.label}: KES ${Number(ctx.parsed.y).toLocaleString('en-US')}` },
            },
          },
          scales: {
            x: { stacked: true, grid: { display: false }, border: { display: false }, ticks: { font: { size: 11 }, color: '#94a3b8', maxRotation: 0, autoSkip: true } },
            y: { stacked: true, beginAtZero: true, grid: { color: 'rgba(0,0,0,0.04)' }, border: { display: false }, ticks: { font: { size: 11 }, color: '#94a3b8', callback: v => this.short(v).replace('KES ', '') } },
          },
        },
      });
    },
  },
};
</script>
